/** How a readiness verdict reads on screen. */

import type { TypeReadiness, TypeReadinessVerdict } from './types';

export const VERDICT_LABELS: Record<TypeReadinessVerdict, string> = {
	ready: 'Ready',
	not_ready: 'Not ready',
	stale: 'Stale',
	no_run: 'Not tested'
};

/** A pass rate as a whole percent: "90%". */
export const percent = (rate: number): string => `${Math.round(rate * 100)}%`;

/** One line on what the verdict rests on: "9 of 10 passed (90%)", or why there is no verdict yet. */
export const readinessDetail = (readiness: TypeReadiness): string => {
	const { counts, passRate } = readiness;
	if (!counts || passRate === null) return readiness.reason ?? 'No bulk run has finished for this type';
	const tally = `${counts.passed} of ${counts.total} passed (${percent(passRate)})`;
	return readiness.reason ? `${tally}. ${readiness.reason}` : tally;
};
